export class TabOptionModel {
  id: string | number | undefined;
  name: string;
  isActive: boolean;

  constructor(id: string | number | undefined, name: string, isActive: boolean = false) {
    this.id = id;
    this.name = name;
    this.isActive = isActive;
  }
}
